import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://us-central1-clone-b79ad.cloudfunctions.net/api',
  /*http://localhost:5001/clone-b79ad/us-central1/api */
});

export default instance;
